import { useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { aapi, apiErr, fmtDT, useA, useAdminApi } from "./lib";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../components/ui/alert-dialog";

export function ContentSyncCard() {
  const a = useA();
  const { lang } = useI18n();
  const { data, reload } = useAdminApi("/admin/content-sync");
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { const r = await aapi.post("/admin/content-sync"); toast.success(a(`Content synced (${r.data.version})`, `تمت مزامنة المحتوى (${r.data.version})`)); reload(); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); setOpen(false); }
  };
  return (
    <div data-testid="content-sync-card" className="mb-8 rounded-sm border border-ivory/10 p-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="font-display text-xl">{a("Content snapshot", "لقطة المحتوى")}</h2>
          <p className="mt-1 text-xs text-ivory/55" data-testid="content-sync-status">
            {a("Bundled", "المضمّنة")}: {data?.bundled_version || "—"} · {a("Last applied", "آخر تطبيق")}: {data?.last_applied ? `${data.last_applied.version} (${fmtDT(data.last_applied.applied_at, lang)})` : "—"}
          </p>
        </div>
        <button type="button" className="chip" onClick={() => setOpen(true)} disabled={busy} data-testid="content-sync-open"><RefreshCw className={`h-3.5 w-3.5 ${busy ? "animate-spin" : ""}`} />{a("Sync content from bundled snapshot", "مزامنة المحتوى من اللقطة المضمّنة")}</button>
      </div>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="content-sync-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>{a("Sync content from the bundled snapshot?", "مزامنة المحتوى من اللقطة المضمّنة؟")}</AlertDialogTitle>
            <AlertDialogDescription>{a("Settings, projects, properties, hero slides, pages, categories, locations, agents and articles will be overwritten (matched by slug/key) with the bundled version. Leads, appointments, chats, customers, analytics and user passwords are not touched. Nothing is deleted.", "سيتم استبدال الإعدادات والمشاريع والعقارات والشرائح والصفحات والتصنيفات والمواقع والوكلاء والمقالات بالنسخة المضمّنة. لن يتم المساس بالعملاء المحتملين والمواعيد والمحادثات والعملاء والتحليلات وكلمات المرور. لا يُحذف شيء.")}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="content-sync-cancel">{a("Cancel", "إلغاء")}</AlertDialogCancel>
            <AlertDialogAction onClick={(e) => { e.preventDefault(); run(); }} disabled={busy} data-testid="content-sync-confirm">{busy ? "…" : a("Sync now", "زامن الآن")}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
